// Lucide Icons Initialization
// Initializes Lucide icons in the DOM

function initializeLucideIcons() {
  // Check if Lucide is available
  if (typeof lucide !== 'undefined' && lucide.createIcons) {
    lucide.createIcons();
  } else {
    // Wait for Lucide to load
    if (typeof lucide === 'undefined') {
      setTimeout(initializeLucideIcons, 100);
      return;
    }
  }
}

// Initialize icons when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLucideIcons);
} else {
  // DOM is already loaded, initialize immediately
  initializeLucideIcons();
}

// Handle theme editor section reloads
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    // Small delay to ensure DOM is updated
    setTimeout(initializeLucideIcons, 50);
  });
  
  // Also handle section select/unselect events
  document.addEventListener('shopify:section:select', function(event) {
    setTimeout(initializeLucideIcons, 50);
  });
  
  document.addEventListener('shopify:section:deselect', function(event) {
    setTimeout(initializeLucideIcons, 50);
  });
}

// Make the function globally available for dynamic content
window.initializeLucideIcons = initializeLucideIcons;


